import { intervalToDuration } from 'date-fns';

export const duration = (start: Date, end: Date = new Date()) =>
  intervalToDuration({
    start,
    end,
  });
